import React from 'react';
import type { MenuLanguage, ServerStats } from './types.js';
import { MatchmakingStatus } from './MatchmakingStatus.js';
import { MenuVisualizer } from './MenuVisualizer.js';
import type { AudioManager } from '../../audio/manager.js';

export function PlayPanel({
  language, name, inQueue, position, playersWaiting, estimatedWait, stats, onNameChange, onPlay, onLeave, onCustomize, audio, onPlayBots,
}: {
  language: MenuLanguage;
  name: string;
  inQueue: boolean;
  position: number;
  playersWaiting: number;
  estimatedWait: number;
  stats: ServerStats | null;
  onNameChange: (name: string) => void;
  onPlay: () => void;
  onLeave: () => void;
  onCustomize: () => void;
  audio: AudioManager;
  onPlayBots: () => void;
}) {
  const es = language === 'es';
  const tr = (spanish: string, english: string, french: string) =>
    es ? spanish : language === 'fr' ? french : english;
  return (
    <main className="play-panel">
      <div className="hero-visualizer">
        <MenuVisualizer audio={audio} />
        <img className="hero-logo" src="/assets/Logo.png" alt="Push.io" />
      </div>
      <div className="hero-copy">{tr('Empuja. Sobrevive. Gana.', 'Push. Survive. Win.', 'Poussez. Survivez. Gagnez.')}</div>
      {!inQueue ? <>
        <input className="player-name-input" value={name} maxLength={16} autoComplete="off"
          aria-label={tr('Nombre del jugador', 'Player name', 'Nom du joueur')}
          placeholder={tr('Introduce tu nombre', 'Enter your name', 'Entrez votre nom')}
          onChange={(event) => onNameChange(event.target.value)}
          onKeyDown={(event) => { if (event.key === 'Enter') onPlay(); }} />
        <button className="play-button" onClick={onPlay}>{tr('JUGAR', 'PLAY', 'JOUER')}</button>
      <button className="bot-match-button" onClick={onPlayBots}>
        {tr('CONTRA LA MÁQUINA', 'VS MACHINE', 'CONTRE LA MACHINE')}
      </button>
      <button className="customize-button" onClick={onCustomize}>
        {tr('PERSONALIZAR', 'CUSTOMIZE', 'PERSONNALISER')}
      </button>
        <div className="match-caption">{tr('Hasta 32 jugadores • Arena competitiva', 'Up to 32 players • Competitive arena', "Jusqu'à 32 joueurs • Arène compétitive")}</div>
        {stats && <div className="server-stats">
          <span><strong>{stats.sessions}</strong> {tr('conectados', 'online', 'connectés')}</span>
          <span><strong>{stats.rooms}</strong> {tr('partidas activas', 'active matches', 'parties actives')}</span>
          <span><strong>{stats.queue}</strong> {tr('en cola', 'queued', 'dans la file')}</span>
        </div>}
      </> : <MatchmakingStatus language={language} position={position}
        playersWaiting={playersWaiting} estimatedWait={estimatedWait} onCancel={onLeave} />}
    </main>
  );
}
